import { DEVICE_ID_KEY, JWT_TOKEN_KEY, REFRESH_TOKEN_KEY } from "../../constants/auth";
import { v4 as uuidv4 } from 'uuid';
export const getLocalStorage = (key: string) => {
  return localStorage.getItem(key);
};

export const setLocalStorage = (key: string, value: string) => {
  localStorage.setItem(key, value);
};

export const removeLocalStorage = (key: string) => {
  localStorage.removeItem(key);
};

export const getAndParseLocalStorage = (key: string) => {
  const value = localStorage.getItem(key);
  return value ? JSON.parse(value) : null;
};

export const setAndStringifyLocalStorage = (key: string, value: any) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const clearTokenLocalStorage = () => {
  removeLocalStorage(JWT_TOKEN_KEY);
  removeLocalStorage(REFRESH_TOKEN_KEY);
};


export const checkDeviceId = () => {
  let deviceId = getLocalStorage(DEVICE_ID_KEY);
  if (!deviceId) {
    deviceId = uuidv4();
    setLocalStorage(DEVICE_ID_KEY, deviceId);
  }

  return deviceId;
};
